export function getPhoneNumber(phone) {
    let pphone = "";
    if (phone) {
        pphone =
            phone.slice(0, 3) + " " + phone.slice(3, 6) + " " + phone.slice(6);
    }
    return pphone;
}

export function containsPartFromArray(arr, str) {
    let parts = str.split(",");
    for (let part of parts) {
        if (arr.includes(part)) {
            return true;
        }
    }
    return false;
}
